import react from "react";
import './Main.css'
import Canvas from "../Canvas/Canvas";

function Main() {
    return (
        <div className="mainWrapper">
            <div className="main">
                <h1>ООО НПП "АЛЬФА-КОСМОС"</h1>
                <p>аттестовано Федеральным космическим агентством как орган по сертификации космических аппаратов, модулей орбитальных станций, радиотехнических и 
    квантово-оптических систем, аппаратуры космических комплексов.</p>
            </div>
            <Canvas />
        </div>
    )
}

export default Main;